import { ChangeEvent, useState, useEffect } from 'react';
import {
  Divider,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  CardHeader,
  CardContent,
  Container,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import InvoiceTableRow from './InvoiceTableRow';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
// import { useDebounce } from "src/hooks/useDebounce";
import { useSearchParams } from 'react-router-dom';
// import ModalsWrapper from "src/components/Modals/ModalsWrapper";
// import CreateInvoice from "./CreateInvoice";
import { HttpClient } from 'src/Helpers/http/http';
// import CreateManualInvoice from "./CreateManualInvoice";
import { debounce } from 'lodash';

import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import CreateInvoice from './CreateInvoice';
import CreateManualInvoice from './CreateManualInvoice';
import { IInvoice } from './types/invoiceType';
const InvoiceTable = () => {
  const [limit, setLimit] = useState<number>(30);
  const [total, setTotal] = useState<number>(0);
  const [openManual, setOpenManual] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [allInvoices, setAllInvoices] = useState<IInvoice[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [_searchInvoiceVal, _setSearchInvoiceVal] = useState<string>('');
  // const searchQuery = useDebounce(searchInvoiceVal, 1000);
  const [refresh, setRefresh] = useState(false);

  const [filterItem, setFilterItem] = useState({
    receipt_no: '',
    company_name: '',
  });
  const [searchParams, setSearchParams] = useSearchParams({
    page: '0',
  });
  const [status, setStatus] = useState<string>('all');
  const page = parseInt(searchParams.get('page'));

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        let uri = `/api/atab/admin/invoice?limit=${limit}&skip=${limit * page}`;
        if (filterItem.receipt_no) {
          uri += `&invoice_no=${filterItem?.receipt_no}`;
        }
        if (filterItem.company_name) {
          uri += `&company_name=${filterItem?.company_name}`;
        }

        if (status !== 'all') {
          uri += `&status=${status}`;
        }
        const res: any = await HttpClient.get(uri);

        if (res.success) {
          setAllInvoices(res.data);
          setLoading(false);
          setTotal(res.total);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [
    page,
    limit,
    filterItem.company_name,
    filterItem.receipt_no,
    refresh,
    status,
  ]);

  const handlePageChange = (_event: any, newPage: number): void => {
    searchParams.set('page', newPage.toString());
    setSearchParams(searchParams);
  };
  // const handleStatus = (e: SelectChangeEvent<string>) => {
  //   searchParams.set("status", e.target.value);
  //   setSearchParams(searchParams);
  // };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  // const paginatedInvoice = applyPagination(allInvoices, page, limit);

  const handelInputChange = debounce((value: string, key: string) => {
    setFilterItem((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  }, 2000);
  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <Card>
            <CardHeader
              action={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1,
                  }}
                >
                  <TextField
                    label='Search by invoice no'
                    id='standard-search'
                    type='search'
                    size='small'
                    variant='outlined'
                    onChange={
                      (e: React.ChangeEvent<HTMLInputElement>) =>
                        handelInputChange(e.target.value, 'receipt_no')
                      // setSearchInvoiceVal(e.target.value)
                    }
                  />
                  <TextField
                    label='Search by company name'
                    id='standard-search'
                    type='search'
                    size='small'
                    variant='outlined'
                    onChange={
                      (e: React.ChangeEvent<HTMLInputElement>) =>
                        handelInputChange(e.target.value, 'company_name')
                      // setSearchInvoiceVal(e.target.value)
                    }
                  />
                  <FormControl sx={{ width: '150px' }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      label='Status'
                      size='small'
                    >
                      {[
                        {
                          id: 'all',
                          name: 'All',
                        },
                        {
                          id: 'unpaid',
                          name: 'Unpaid',
                        },
                        {
                          id: 'paid',
                          name: 'Paid',
                        },
                      ].map((statusOption) => (
                        <MenuItem key={statusOption.id} value={statusOption.id}>
                          {statusOption.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Button
                    size='small'
                    onClick={() => setOpen(true)}
                    variant='contained'
                  >
                    Create an invoice
                  </Button>
                  {/* <Button
                    onClick={() => setOpenManual(true)}
                    variant="contained"
                  >
                    Create manual invoice
                  </Button> */}
                </Box>
              }
              title={`Invoice list (${total})`}
            />
            <Divider />

            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SL</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Invoice no</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Total Amount</TableCell>
                      <TableCell>Due Amount</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableLoader />
                    ) : allInvoices.length ? (
                      <>
                        {allInvoices?.map((sInvoice, index: number) => (
                          <InvoiceTableRow
                            key={sInvoice.atab_payment_invoice_id}
                            sInvoice={sInvoice}
                            index={index}
                            allInvoices={allInvoices}
                            setAllInvoices={setAllInvoices}
                          />
                        ))}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box p={2}>
                <TablePagination
                  component='div'
                  count={total}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page && page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[25, 50, 75, 100]}
                />
              </Box>
            </CardContent>

            {/* Modal */}
            <ModalsWrapper
              modalData={{ title: 'Create invoice' }}
              setShowModal={setOpen}
              showModal={open}
            >
              <CreateInvoice handleClose={setOpen} setRefresh={setRefresh} />
            </ModalsWrapper>

            {/* mamual invoice  */}
            <ModalsWrapper
              modalData={{ title: 'Create manual invoice' }}
              setShowModal={setOpenManual}
              showModal={openManual}
            >
              <CreateManualInvoice handleClose={() => setOpenManual(false)} />
            </ModalsWrapper>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default InvoiceTable;
